import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import DisplayResources from '../crud/DisplayResources';
import { resourceFields } from '../../data/Constants';
import LoadingBar from '../share/LoadingBar';

class Products extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {
    const {
      loading, products, actions, apiToken,
    } = this.props;
    if (loading === false && !products) {
      actions.getAllResources(apiToken, 'products');
    }
  }

  componentDidUpdate = () => {
    const { loading, product } = this.props;
    if (loading === false && !products) {
      actions.getAllResources(apiToken, 'products');
    }
  }

  render() {
    const {
      products, actions, loading, apiToken,
    } = this.props;
    const itemsButton = [{ id: 1, btnTitle: 'items' }];
    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <DisplayResources
            data={products}
            actions={actions}
            fieldNames={resourceFields.products}
            resourceName="products"
            buttonArray={itemsButton}
            apiToken={apiToken}
          />
        )
    );
  }
}

Products.propTypes = {
  loading: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
};

Products.defaultProps = {
  products: null,
};

export default withRouter(Products);
